var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sliding-tabs',{staticClass:"NOTIFICATION-TABS",attrs:{"activeTab":_vm.activeNotificationTab}},_vm._l((_vm.tabs),function(tab,index){return _c('sliding-tabs-content',{key:tab.key,attrs:{"name":tab.key,"titleProps":{
        title: tab.label,
        titleClass: (index ? 'text-capitalize p-x-2' : 'FIRST-TAB-TITLE p-x-2'),
        to: {
          name: 'dashboard::pro::notifications',
          params: { activeNotificationTab: tab.key }
        },
      }}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }